module.exports = __webpack_public_path__ + "static/media/5.faff0439.jpg";